export default function AuthCheckbox({ checked, onChange, children, error = false }) {
  const toggle = () => onChange(!checked);

  const onLabelClick = (e) => {
    if (e.target.closest('a, button')) return;
    toggle();
  };

  return (
    <div className={`switcher agreement-switcher${error ? ' switcher_error' : ''}${checked ? ' switcher_checked' : ''}`}>
      <input
        className="switcher__input"
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        tabIndex={-1}
        aria-hidden
      />
      <label
        className="switcher__block"
        onClick={onLabelClick}
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            if (e.target.closest('a, button')) return;
            e.preventDefault();
            toggle();
          }
        }}
        role="checkbox"
        aria-checked={checked}
        tabIndex={0}
      >
        <span className="switcher__container" aria-hidden>
          <span className="switcher__button" />
        </span>
        <span className="switcher__block-text">
          <span className="description">{children}</span>
        </span>
      </label>
    </div>
  );
}
